import { useEffect, useContext } from 'react';
import { useApi } from './useApi';
import { AuthContext } from 'appRoot/auth/AuthContext';

const useSubscription = () => {
   const { authState } = useContext(AuthContext);

   const { status: subscriptionStatus, sendRequest: sendUserProfileRequest, response:subscription } =
      useApi();

   const mapUserProfileResponse = (unmappedResponse) => {
      if (!unmappedResponse) {
         return null;
      }

      const { subscription: newSubscription } = unmappedResponse;

      if (newSubscription) {
         newSubscription.subscriptionIsStarted =
            new Date(newSubscription?.termStart) <= new Date();
      }

      return newSubscription;
   };

   useEffect(() => {
      if (authState === 'loggedIn') {
          sendUserProfileRequest({
             method: 'get',
             apiName: 'rnd',
             path: '/b/api/user',
             mapResponse: mapUserProfileResponse,
          });
      }
      
      // disabled because we don't expect sendUserProfileRequest to ever change
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [authState]);

   return { subscription, subscriptionStatus };
};

export { useSubscription };
